import { stringify } from 'query-string';

const generateQuery = (params) => {
  if (params && Object.keys(params).length) {
    return `?${stringify(params, { arrayFormat: 'comma', encode: false })}`;
  }
  return '';
};

export default generateQuery;
